module.exports = __webpack_public_path__ + "static/media/14_tn.c1b19950.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/14_tn.jpg
// module id = 152
// module chunks = 0